<ng-container *ngIf="userModel.isAdmin$ | async">
  <app-admin-settings></app-admin-settings>
</ng-container>

<ng-container *ngIf="userModel.isDoctor$ | async">
  <app-doctor-settings></app-doctor-settings>
</ng-container>